import { sendForm } from './sendForm';

window.cars = function(onlySold = false) {
	return {
		cars: [],
		page: 1,
		hasMore: true,
		loading: true,
		search: null,
		filterData: null,
		skelentons: 6,
		onlySold: onlySold,
		filters: {
			'models': [],
			'bodyworks': [],
			'selectedBrand': null,
		},

		async init() {
			await this.loadFunction();

			const response = await sendForm({
				action: 'getCarFilterData'
			});

			this.filterData = response.data;
		},

		load() {
			this.page++;
			this.loadFunction();
		},

		initSearch() {
			const form = this.$refs.form;
			const formData = new FormData(form);
			this.cars = [];

			this.search = JSON.stringify(Object.fromEntries(formData.entries()));

			this.loadFunction();
		},

		async loadFunction() {
			this.loading = true;
			try {
				const response = await sendForm({
					action: 'getCars',
					paged: this.page,
					search: this.search,
					only_sold: this.onlySold ? 1 : 0,
				});

				if ( this.search ) {
					this.skelentons = 3;
				}

				this.cars.push(
					...response.data.cars.filter(car => !this.cars.some(c => c.id === car.id))
				);

				this.hasMore = response.data.has_more;
			} catch (error) {
				console.error('Error fetching cars:', error);
			} finally {
				this.loading = false;
			}
		},

		updateModels( value ) {
			this.filters.models = Object.keys(this.filterData[value]['models']);
			this.filters.selectedBrand = value;
		},

		updateBodyworks( value ) {
			this.filters.bodyworks = this.filterData[this.filters.selectedBrand]['models'][value].bodyworks;
		}
	};
};


window.loan = function (data) {
	return {
		result: 0,
		loading: false,

		init() {
			this.calculate();
		},

		async calculate() {
			const form = this.$root;
			const formData = new FormData(form);

			if ( ! formData.get('action') ) {
				formData.append('action', 'sendContactForm');
			}

			this.loading = true;

			const response = await sendForm(formData);

			this.loading = false;

			if ( response.success ) {
				this.result = response.data;
			} else {
				this.result = 0;
			}
		},
	}
}
